var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuxCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 513,
    height: 500,
    viewBox: "0 0 513 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 371.6L131.2 500l99.5-97.3-23-22.5-73.4 71.8L26 346.2 0 371.6zm297.3-131.5c13.9 13.9 14.8 23.2 14.4 33.5-.2 11.3-7.2 23.4-17.6 33.8l-.1.1c-10.5 10.4-22.1 17-33.5 17.2-10.3.4-19.1-1-33.1-14.9l-74.7-74.6-24.5 24.5 72.8 72.7c23.7 23.7 41.6 27.6 60.8 26.5 17.6-1 36.9-10.7 54.9-28.6 17.9-18 28.2-37.8 29.2-55.3 1.1-19.1-2.3-37.5-26.1-61.2L247.1 141l-24.6 24.5 74.8 74.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M413 0h-31.2v99.8H282V131h99.8v99.8H413V131h99.8V99.8H413V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuxCap);
export default __webpack_public_path__ + "static/media/LuxCap.a2b631a6303d219cb5f11ba1720c499c.svg";
export { ForwardRef as ReactComponent };